var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card bg" }, [
    _c(
      "div",
      { staticClass: "clearfix" },
      [
        _c(
          "el-button",
          {
            staticStyle: { float: "right", padding: "3px 0" },
            attrs: { type: "text" },
            on: { click: _vm.togglePhdRegistration }
          },
          [_vm._v("\n      Κλείσιμο\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "el-button",
          {
            attrs: {
              type: "primary",
              icon: "el-icon-refresh",
              loading: _vm.refreshingList,
              disabled: _vm.waiting
            },
            on: { click: _vm.refreshLists }
          },
          [_vm._v("\n      Ενημέρωση\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "to-register-title" }, [
      _vm._v("\n    Διδακτορικά προς καταχώριση στο ΕΑΔΔ\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.phdRegistrationList,
              "default-sort": _vm.registrationListSort,
              "header-cell-style": { padding: "12px 0" },
              "cell-style": { padding: "12px 0" }
            }
          },
          [
            _c("el-table-column", {
              attrs: { label: "Καταχώριση", width: "105", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-popover",
                        {
                          attrs: { placement: "right" },
                          model: {
                            value: scope.row.confirmVisible,
                            callback: function($$v) {
                              _vm.$set(scope.row, "confirmVisible", $$v)
                            },
                            expression: "scope.row.confirmVisible"
                          }
                        },
                        [
                          _c("div", { staticClass: "dialog-text" }, [
                            _vm._v(
                              "\n              Καταχώριση της αίτησης στο ΕΑΔΔ?"
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "strong-text" }, [
                              _vm._v(
                                _vm._s(scope.row.appId) +
                                  ": " +
                                  _vm._s(scope.row.fullName)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dialog-buttons" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function($event) {
                                      scope.row.confirmVisible = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Ακύρωση\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.registerApp(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Συνέχεια\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              slot: "reference",
                              type: "success",
                              size: "mini",
                              icon: "el-icon-upload2",
                              loading: scope.row.loading,
                              disabled: _vm.waiting
                            },
                            slot: "reference"
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "appId",
                label: "Αρ. αίτησης",
                width: "130",
                align: "center",
                sortable: ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "fullName",
                label: "Ονοματεπώνυμο",
                width: "300",
                sortable: ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "protocol",
                label: "Αρ. Πράξης",
                width: "140",
                align: "center",
                sortable: ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "applicationTime",
                label: "Οριστική υποβολή",
                width: "172",
                align: "center",
                "render-header": _vm.renderApplicationHeader,
                sortable: ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "50", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              scope.row.appId + ": Τίτλος 3ου κύκλου σπουδών",
                            placement: "top-start",
                            effect: "light"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "text",
                              size: "medium",
                              icon: "el-icon-document",
                              disabled: _vm.waiting
                            },
                            on: {
                              click: function($event) {
                                _vm.showAttachment(
                                  scope.row.appId,
                                  scope.row.diplomaFileId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "50", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: scope.row.appId + ": Δήλωση συναίνεσης",
                            placement: "top-start",
                            effect: "light"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "text",
                              size: "medium",
                              icon: "el-icon-document",
                              disabled: _vm.waiting
                            },
                            on: {
                              click: function($event) {
                                _vm.showAttachment(
                                  scope.row.appId,
                                  scope.row.consentFileId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "recognitionTime",
                label: "Ψηφιακή υπογραφή",
                width: "172",
                align: "center",
                "render-header": _vm.renderRecognitionHeader,
                sortable: ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "50", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: scope.row.appId + ": Πράξη αναγνώρισης",
                            placement: "top-start",
                            effect: "light"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "text",
                              size: "medium",
                              icon: "el-icon-document",
                              disabled: _vm.waiting
                            },
                            on: {
                              click: function($event) {
                                _vm.showAttachment(
                                  scope.row.appId,
                                  scope.row.praxiFileId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        [
          _c("el-button", {
            staticStyle: { float: "right", padding: "15px 0px" },
            attrs: { type: "text", icon: _vm.moreIcon },
            on: {
              click: function($event) {
                _vm.registeredPhdsDisplayed = !_vm.registeredPhdsDisplayed
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.registeredPhdsDisplayed
        ? _c("div", { staticClass: "registered-title" }, [
            _vm._v(
              "\n      Καταχωρηθέντα Διδακτορικά στο ΕΑΔΔ (από την εφαρμογή eDoatap)\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.registeredPhdsDisplayed
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.registeredPhdsList,
                    "default-sort": _vm.registeredSort,
                    "header-cell-style": { padding: "12px 0" },
                    "cell-style": { padding: "12px 0" }
                  }
                },
                [
                  _vm.debug
                    ? _c("el-table-column", {
                        attrs: {
                          label: "Διαγραφή",
                          width: "105",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    type: "danger",
                                    size: "mini",
                                    icon: "el-icon-delete",
                                    loading: scope.row.loading,
                                    disabled: _vm.waiting
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.deleteRegistration(scope.row)
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "eaddId",
                      label: "ΕΑΔΔ ID",
                      width: "100",
                      align: "center",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "registrationTime",
                      label: "Καταχώριση",
                      width: "160",
                      align: "center",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "appId",
                      label: "Αρ. αίτησης",
                      width: "130",
                      align: "center",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fullName",
                      label: "Ονοματεπώνυμο",
                      width: "300",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "protocol",
                      label: "Αρ. Πράξης",
                      width: "140",
                      align: "center",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recognition",
                      label: "Αναγνώριση",
                      width: "130",
                      align: "center",
                      sortable: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f20a3b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f20a3b8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PhdRegistration.vue
// module id = null
// module chunks = 